/*
 * @Description: 
 * @Version: 1.0
 * @Author: tu
 * @Date: 2023-12-26 16:11:18
 * @LastEditors: tu
 * @LastEditTime: 2024-03-14 16:05:33
 * @FilePath: /clinic-home-web/src/utils/util.js
 */
// 获取数据对应的keyList对应数据
export const getDataValue = (data, keyList) => {
  let res = data

  for (let i = 0; i < keyList.length; i++) {
    const key = keyList[i];
    if (!res) {
      return '--'
    }
    res = res[key]
  }
  return res || '--'
}
/**
 * @description:  获取选项label 
 * @param {T extends Record<string, any>} options 选项
 * @param {any} value 选项值
 * @param {K extends keyof T} key 选项key
 * @param {K extends keyof T} k 选项label 要输出的key
 * @return {*}
 */
export const optionsLabelGetter = (options, value, key = 'key', k = 'value', defaultValue = '') => {
  const option = options.find((u) => u[key] == value)
  return option ? option[k] : defaultValue
}

export const medTypeOptions = [
  { key: '1', value: '自费' },
  { key: '11', value: '普通门诊' },
  { key: '14', value: '慢特病门诊' },
  { key: '9935', value: '独立门诊部个人帐户支付' },
]
export const medTypeFilter = (value) => optionsLabelGetter(medTypeOptions, value, 'key', 'value', '自费')

//  1:预订单  2:订单完成 3订单失效 4订单撤销 5订单删除
export const orderStatusOptions = [
  { key: 1, value: '待收费' },
  { key: 2, value: '订单完成' },
  { key: 3, value: '订单失效' },
  { key: 4, value: '订单撤销' },
  { key: 5, value: '订单删除' },
]
export const orderStatusFilter = (value) => optionsLabelGetter(orderStatusOptions, value, 'key', 'value', '待收费')

export const getHiMedType = (key) => {
  let _key = key + ''
  return {
    '1': '自费',
    '11': '普通门诊',
    '41': '定点药店购药',
    '9935': '独立门诊部个人帐户支付'
  }[_key] || _key
}

// 防抖 含义：在一段时间内，不管触发多少次回调，只执行最后一次
export const useDebounce = (fn, delay = 300) => {
  let timer = null
  return function () {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      fn.apply(this, arguments)
    }, delay)
  }
}
// 节流 含义：在一段时间内，不管触发多少次回调，只执行一次
export const throttle = (fn, delay = 300) => {
  let flag = true
  return function () {
    if (!flag) return
    flag = false
    setTimeout(() => {
      fn.apply(this, arguments)
      flag = true
    }, delay)
  }
}

export const diagnosisDict = (key) => {
  let obj = {
    5: '医疗器械',
    21: '检验项目',
    22: '检查项目',
    23: '治疗理疗',
    24: '其他费用',
    25: '套餐项目',
  }
  return obj[key]
}

// 上月的第一天，
export const getLastMonthFirstDateStr = () => {
  var lastMonthLastDay = new Date(getLastMonthLastDateStr());
  var y = lastMonthLastDay.getFullYear();
  var m = (lastMonthLastDay.getMonth()+1)<10?"0"+(lastMonthLastDay.getMonth()+1):(lastMonthLastDay.getMonth()+1);//获取当前月份的日期，不足10补0
  return y + "-" + m + "-01" + ' 00:00:00';
}
// 上月的最后一天
export const getLastMonthLastDateStr = () => {
  var dd = new Date();
  var day = dd.getDate();
  dd.setDate(dd.getDate() - day);//获取AddDayCount天后的日期
  var y = dd.getFullYear();
  var m = (dd.getMonth()+1)<10?"0"+(dd.getMonth()+1):(dd.getMonth()+1);//获取当前月份的日期，不足10补0
  var d = dd.getDate()<10?"0"+dd.getDate():dd.getDate();//获取当前几号，不足10补0
  return y + "-" + m + "-" + d + ' 23:59:59';
}

